import {
  isPatrolmanPlusSku,
  isPatrolmanSku,
  isReconSku,
} from "../configuration-sku-family.js";

/** Print-out instruction sheets stocked at Pack Out (station 14) via manufacturing.station_stock. */
export const PREPACK_PRINT_OUT_INSTRUCTION_SKUS = {
  FI_3C: "88-009",
  FI_5A: "88-402",
  FI_5A_W: "88-402-W",
} as const;

const PRINT_OUT_INSTRUCTION_SKU_SET_LOWER = new Set(
  Object.values(PREPACK_PRINT_OUT_INSTRUCTION_SKUS).map((sku) => sku.toLowerCase()),
);

export function isPrepackPrintOutInstructionSku(skuRaw: string): boolean {
  const sku = skuRaw.trim().toLowerCase();
  return PRINT_OUT_INSTRUCTION_SKU_SET_LOWER.has(sku);
}

/** Map a finished device SKU to the print-out instruction sheet SKU consumed at pre-pack. */
export function resolvePrepackPrintOutInstructionSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isPatrolmanPlusSku(finishedSku)) return PREPACK_PRINT_OUT_INSTRUCTION_SKUS.FI_5A_W;
  if (isPatrolmanSku(finishedSku)) return PREPACK_PRINT_OUT_INSTRUCTION_SKUS.FI_5A;
  if (isReconSku(finishedSku)) return PREPACK_PRINT_OUT_INSTRUCTION_SKUS.FI_3C;
  return null;
}
